import React from 'react';
import PropTypes from 'prop-types';
import DateFormatResolver, { fullDateUsFormat } from 'resolvers/date-format.resolver';

// material-ui components
import { withStyles } from '@material-ui/core/styles';

// core components
import ReadOnlyField from 'components/ReadOnlyField/ReadOnlyField';

const styles = {
	wrapper: {},
};

class AuditLog extends React.Component {
	constructor(props) {
    super(props);
	}

  render() {
		const { classes, createdBy, createdAt, modifiedBy, modifiedAt } = this.props;

		return (<div className={classes.wrapper} >
			<ReadOnlyField
				label='Created by'
				value={ createdBy || '' }
			/>
			<ReadOnlyField
				label='Created at'
				value={ DateFormatResolver.resolve(createdAt, fullDateUsFormat) }
			/>
			<ReadOnlyField
				label='Modified by'
				value={ modifiedBy || '' }
			/>
			<ReadOnlyField
				label='Modified at'
				value={ DateFormatResolver.resolve(modifiedAt, fullDateUsFormat) }
			/>
		</div>);
  }
}

AuditLog.propTypes = {
	createdBy: PropTypes.node,
	createdAt: PropTypes.node,
	modifiedBy: PropTypes.node,
	modifiedAt: PropTypes.node,
};

export default withStyles(styles)(AuditLog);
